import { useRef, useState } from "react";
import api from "@/lib/api";
import { Upload, Loader2, CheckCircle2, X } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FileUpload({ value, onChange, label = "Upload file", accept = "image/*", testid }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr(""); setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND_URL}${data.url}`);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="block" data-testid={testid}>
      <span className="block text-[11px] uppercase tracking-widest text-slate-500 mb-1 font-semibold">{label}</span>
      <input ref={inputRef} type="file" accept={accept} onChange={handle} className="hidden" />
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="inline-flex items-center gap-2 px-3 py-2 border border-slate-300 rounded-md text-sm bg-white hover:border-nkf-blue/50 transition disabled:opacity-60"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4 text-nkf-blue" />}
          {uploading ? "Uploading…" : (value ? "Replace file" : "Choose file")}
        </button>
        {value && (
          <>
            <CheckCircle2 className="h-4 w-4 text-emerald-600" />
            <a href={value} target="_blank" rel="noreferrer" className="text-xs text-nkf-blue hover:underline truncate max-w-xs">View</a>
            <button type="button" onClick={() => onChange("")} className="text-red-600" aria-label="Clear">
              <X className="h-4 w-4" />
            </button>
          </>
        )}
      </div>
      {err && <div className="mt-1 text-xs text-red-600">{err}</div>}
      {value && /\.(jpe?g|png|gif|webp|svg)$/i.test(value) && (
        <img src={value} alt="" className="mt-2 h-20 w-20 object-cover rounded border border-slate-200" />
      )}
    </div>
  );
}
